<template>

    <div class="sb_block_items">
        <div class="sb_block_row item" v-for="(item,index) in basket" :key="index" >
            <a class="sb_link_pic" :href="item.DETAIL_PAGE_URL" target="_blank">
                <div class="sb_pic"><img :src="item.IMAGE" alt=""></div>
            </a>
            <div class="sb_block_info">
                <a :href="item.DETAIL_PAGE_URL" target="_blank">
                    <div class="sb_name">{{item.NAME}}</div>
                </a>
                <div class="sb_wight"><span>Вес:</span> {{item.WEIGHT}} кг.</div>
            </div>
            <div class="sb_block_mobile">
                <div class="sb_block_price">
                    <div class="sb_value">{{item.PRICE}} {{item.PRICE_SUMBOL}}</div>
                    <div class="sb_text">Цена за 1 {{item.MEASURE}}.</div>
                </div>
                <div class="sb_block_action">
                    <div class="sb_action">
                        <div class="minus" @click="minus(index)"><img src="/images/basket/minus.png" alt=""></div>
                        <el-input v-model="basket[index].QUANTITY" :min="1"
                                  @input="onQuantityChange(index)"
                        ></el-input>
                        <div class="plus" @click="plus(index)"><img src="/images/basket/plus.png" alt=""></div>
                    </div>
                    <div class="sb_text"></div>
                </div>
                <div class="sb_block_summ">
                    <div class="sb_value">{{basket[index].SUM}} {{item.PRICE_SUMBOL}}</div>
                </div>
            </div>
            <div class="sb_block_del" @click="deleteitem(index)">x</div>
        </div>
    </div>

    <div class="sb_block_service" v-if="service.length > 0">
        <div class="sb_title">Вам могут понадобиться следующие услуги:</div>
        <div class="sb_block_list" v-for="(itemService,indexService) in service" :key="indexService" >
            <div class="sb_service" :class="{'sb_active':itemService.IN_BASKET}">
                <div class="sb_info">
                    <div class="sb_left">
                        <img class="sb_img" v-if="itemService.PROPERTY_SIDE_IMAGE_VALUE" :src="itemService.PROPERTY_SIDE_IMAGE_VALUE" :alt="itemService.NAME">
                        <span v-html="itemService.NAME"></span>
                    </div>
                    <div class="sb_right" v-if="itemService.PROPERTY_PRICE_VALUE" :class="{'sb_margin_left_40': itemService.PROPERTY_SIDE_IMAGE_VALUE !== ''}">
                        <span v-if="itemService.PROPERTY_PRICE_VALUE">от  {{itemService.PROPERTY_PRICE_VALUE}} ₽/услугу</span>
                    </div>
                </div>
                <div class="sb_action">
                    <div class="btn sb_service_add" @click="addService(indexService)" v-if="itemService.IN_BASKET == false">Добавить к заказу</div>
                    <div delete="Удалить из корзины" @click="deleteService(indexService)" v-if="itemService.IN_BASKET == true" class="btn btn-default sb_service_add">Добавлено к заказу</div>
                </div>
            </div>
        </div>
    </div>
    <div class="sb_block_result">
        <div class="sb_h1">Итого:</div>
        <div class="sb_block_row">
            <div class="sb_table">
                <div class="sb_summ_weight">Общий вес: {{allWeight_FORMATED}}</div>
                <div class="sb_summ_quantity">Всего товаров: {{countProduct}} шт</div>
                <div class="sb_list_service" ><span v-if="basketService.length > 0">Добавленные услуги:</span>
                    <template v-for="(itemService,indexService) in service" :key="indexService" >
                        <div v-if="itemService.IN_BASKET" v-html="itemService.NAME"></div>
                    </template>
                </div>
            </div>
            <div class="sb_summ_price">
                <div class="sb_title_summ">Итого:</div>
                <span id="sb_result_basket">{{allSum_FORMATED}}</span>
            </div>
            <div class="sb_action">
                <div class="btn btn-lg btn-default basket-btn-checkout" @click="linkChecked()">Оформить заказ</div>
                <div class="btn btn-lg btn-default sb_btn_auth" @click="AuthChecked()">Авторизоваться</div>
            </div>
        </div>
    </div>
</template>
<script src="./basket/script.js"></script>
